import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { CustomerTaxExemptionInfo } from '../fragments';

export default gql`
  mutation ActionCustomerTaxExemptionStatus(
    $input: CustomerTaxExemptionStatusActionInput!
  ) {
    actionCustomerTaxExemptionStatus(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      customerTaxExemption {
        ...CustomerTaxExemptionInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${CustomerTaxExemptionInfo}
`;
